import { Admin, Resource, CustomRoutes } from 'react-admin';
import { Route } from 'react-router-dom';
import { authProvider } from './authProvider';
import { dataProvider } from './dataProvider';
import { theme } from './theme';
import { CustomLayout } from './layout/CustomLayout';
import { Dashboard } from './dashboard/Dashboard';
import { UserList } from './users/UserList';
import { UserShow } from './users/UserShow';
import { ServiceList } from './services/ServiceList';
import { CountryList } from './countries/CountryList';
import { HistoryList } from './history/HistoryList';
import { ActivationList } from './activations/ActivationList';
import { WebhookLogList } from './webhook-logs/WebhookLogList';
import SettingsPage from './settings/SettingsPage';
import PopularServicesPage from './settings/PopularServicesPage';
import ExcludedServicesPage from './settings/ExcludedServicesPage';
import ExcludedCountriesPage from './settings/ExcludedCountriesPage';
import PersonIcon from '@mui/icons-material/Person';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PublicIcon from '@mui/icons-material/Public';
import HistoryIcon from '@mui/icons-material/History';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import WebhookIcon from '@mui/icons-material/Webhook';

function App() {
  return (
    <Admin
      authProvider={authProvider}
      dataProvider={dataProvider}
      theme={theme}
      layout={CustomLayout}
      dashboard={Dashboard}
      title="SMS Hero Admin"
    >
      <Resource
        name="users"
        list={UserList}
        show={UserShow}
        icon={PersonIcon}
        options={{ label: 'Kullanıcılar' }}
      />
      <Resource
        name="admin/sms/services"
        list={ServiceList}
        icon={PhoneAndroidIcon}
        options={{ label: 'Servisler' }}
      />
      <Resource
        name="admin/sms/countries"
        list={CountryList}
        icon={PublicIcon}
        options={{ label: 'Ülkeler' }}
      />
      <Resource
        name="admin/sms/activations"
        list={ActivationList}
        icon={ConfirmationNumberIcon}
        options={{ label: 'Aktivasyonlar' }}
      />
      <Resource
        name="admin/sms/history"
        list={HistoryList}
        icon={HistoryIcon}
        options={{ label: 'Geçmiş' }}
      />
      <Resource
        name="admin/sms/webhook-logs"
        list={WebhookLogList}
        icon={WebhookIcon}
        options={{ label: 'Webhook Logları' }}
      />
      <CustomRoutes>
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/popular-services" element={<PopularServicesPage />} />
        <Route path="/excluded-services" element={<ExcludedServicesPage />} />
        <Route path="/excluded-countries" element={<ExcludedCountriesPage />} />
      </CustomRoutes>
    </Admin>
  );
}

export default App;
